<template>
	<div class="container-fluid">
		<div id="topo" class="card-header">
			<div class="row">
				<div class="col col-xs-2">
					<h4 class="panel-title">
						<span class="title">Consulta de Obras.</span>
						<br />
						<span class="navigation">Obras > Consulta</span>
					</h4>
				</div>
			</div><!--row-->
		</div><!--card-header-->

		<div class="card-body">
			<div class="row">
				<div class="col-md-6 mb-2">
					<label for="filtro">Filtro:</label>
					<span class="p-fluid">
						<InputText type="text" id="filtro" v-model="filtro" />
					</span>
				</div>
				<div class="mb-2">
					<label for="btnSearch">&nbsp;</label>
					<span class="p-fluid">
						<Button label="Pesquisar" title="Pesquisar" icon="pi pi-search" :disabled="search"
							@click="pesquisar()" />
					</span>
				</div>
				<div class="mb-2" style="padding-left:2px">
					<label for="btnSearch">&nbsp;</label>
					<span class="p-fluid">
						<Button label="Limpar" title="Limpar" icon="pi pi-trash" :disabled="search" @click="clear()" />
					</span>
				</div>
			</div><!--row-->

			<div class="row">
				<DataTable :value="obrasList" :paginator="true" :rows="10" class="p-datatable-responsive"
					:autoLayout="true">
					<Column headerStyle="width: 12em" bodyStyle="text-align: center">
						<template #body="slotProps">
							<Button type="button" icon="pi pi-print" style="margin-right: .5em" @click="openWindowExercicio(slotProps.data.id, slotProps.data.nome)"></Button>
							<Button type="button" icon="pi pi-pencil" style="margin-right: .5em" @click="detail(slotProps.data.id)"></Button>
							<Button type="button" icon="pi pi-trash" @click="confirmRemove(slotProps.data.id)"></Button>
						</template>
					</Column>
					<Column field="numeroCei" header="Número CEI"></Column>
					<Column field="numeroArt" header="Número ART"></Column>
					<Column field="dataInicialFormatada" header="Data Inicial"></Column>
					<Column field="dataTerminoFormatada" header="Data Final"></Column>
					<Column field="saldoDisponivelFormatado" header="Saldo Disponível"></Column>
					<Column field="saldoDeduzidoFormatado" header="Saldo Deduzido"></Column>
				</DataTable>
			</div><!--row-->
			<hr />

			<div class="row">
				<span class="p-fluid mr-2">
					<router-link to="/obrasCadastro">
						<Button type="button" icon="pi pi-plus" label="Novo" title="Novo" />
					</router-link>
				</span>
			</div>
		</div><!--card-body-->
		<Dialog header="Aviso" :visible.sync="display" :style="{ width: '30vw' }" :modal="true">
			Confirmar a remoção do Registro?
			<template #footer>
				<Button label="Sim" icon="pi pi-check" @click="remove" title="Sim" />
				<Button label="Não" icon="pi pi-times" @click="close" title="Não" class="p-button-secondary" />
			</template>
		</Dialog>
		<Dialog
      header="Livro Construção Civil"
      :visible.sync="showSelectExerc"
      :style="{ width: '30vw' }"
      :contentStyle="{ overflow: 'visible' }"
      :modal="true"
    >
		<label for="compIni">Exercício: *</label>
      <span class="p-fluid">
				<InputMask
					v-model="exercicio"
					id="compIni"
					mask="9999"
					autocomplete="off"
				/>
      </span>
      <template #footer>
        <Button
          label="Imprimir"
          icon="pi pi-print"
          @click="impressaoSaldoObras()"
          :disabled="loading"
        />
        <Button
          label="Fechar"
          icon="pi pi-times"
          @click="closeWindowExercicio()"
          class="p-button-danger"
        />
      </template>
    </Dialog>
	</div>
</template>

<script>
import LoginService from "../services/acesso/login.service";
import obrasService from '../services/obras/obras.service';
import ReportService from '../services/report.service';

export default {
	name: 'ObrasConsulta',
	data() {
		return{
			loading: false,
			display: false,
			search: false,
			filtro: "",
			showSelectExerc: false,
			obrasList: [],
			id: null,
			currentUser: null,
			exercicio: null,
		}
	},

	created() {
		this.currentUser = LoginService.currentUserValue;
		this.pesquisar();
	},

	methods: {
		clear() {
			this.filtro = "";
			this.pesquisar();
		},
		pesquisar() {
			this.search = true;
			obrasService.findObrasByFiltro(
				this.currentUser.contribuinte.idContribuinte,
				this.filtro
			).then(
				obras => {
					this.obrasList = obras.data;
				},
				error => {
					let errorMessage = "Houve um problema ao listar Obras!";
					if (error.response) {
						errorMessage = error.response.data;
					}
					this.$toast.add({
						severity: "error",
						summary: errorMessage
					});
				}
			);
			this.search = false;
		},
		impressaoSaldoObras() {
			this.processando(true);
			this.obrasId;
			this.nome;
			console.log(this.currentUser.usuario.idCliente);
			ReportService.imprimir("SistemaObras", [
				{
					param: "RP_ID_CLIENTE",
					string: this.currentUser.usuario.idCliente,
				},
				{
					param: "id_obras",
					string: this.obrasId,
				},
				{
					param: "id_contribuinte",
					string: this.currentUser.contribuinte.idContribuinte,
				},
				{
					param: "nome_contribuinte",
					string: this.currentUser.contribuinte.nome,
				},
				{
					param: "nome_obra",
					string: this.nome,
				},
				{
					param: "exercicio",
					string: this.exercicio,
				},
			])
			.then(
				(data) => {
					console.log(data);
				},
				(error) => {
					this.$root.$emit(
						"alert:warn",
						"Erro ao imprimir Saldo de Obras!"
					);
					console.log(error);
				}
			)
			.then(() => {
				this.processando(false);
			});
    },
		openWindowExercicio(id, nome) {
			this.showSelectExerc = true;
			this.obrasId = id;
			this.nome = nome;
		},
		closeWindowExercicio() {
			this.showSelectExerc = false;
		},
		detail(id) {
			this.$router.push({ name: "ObrasCadastro", params: { idObras: id } });
		},
		confirmRemove(id) {
			this.id = id;
			this.display = true;
		},
		close() {
			this.id = null;
			this.display = false;
		},
		remove() {
			obrasService.removeObras(this.id).then(
				data => {
					console.log(data);
					this.$toast.add({
						severity: "success",
						summary: "Obra removida com sucesso"
					});
					setTimeout(async () => {
						await this.pesquisar();
						this.display = false;
					}, 250);
				},
				error => {
					let errorMessage = "Houve um problema ao remover a Obra!";
					if (error.response) {
						errorMessage = error.response.data;
					}
					this.$toast.add({
						severity: "error",
						summary: errorMessage
					});
				}
			);
		},
		processando(show) {
			if (show) {
				this.loading = true;
				this.$root.$emit("loading:show");
			} else {
				this.loading = false;
				this.$root.$emit("loading:hide");
			}
		}
	}
}
</script>